import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DropdownDto} from '../../dto/common/dropDown/dropdown-dto';
import {ApiEndPoint} from '../../utility/api-end-point';
import {TableSearchFilterDataDto} from '../../dto/table/table-search-filter-data-dto';
import {BulkButtonActionDto} from '../../dto/common/bulk-button-action-dto';
import {AppAuthorities} from '../../enums/app-authorities';
import {BatchPayment} from '../../dto/payment/batch-payment';
import {BehaviorSubject} from 'rxjs';
import {CommonUtility} from '../../utility/common-utility';
import {PrivilegeService} from "../privilege.service";
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  public commonUtil: CommonUtility = new CommonUtility();
  updatePaymentSummaryBtnStatus = new BehaviorSubject(null);
  public updateTableData = new BehaviorSubject<boolean>(false);

  constructor(public http: HttpClient, private privilegeService: PrivilegeService) {
  }

  /**
   * Convert objects into forms
   */
  getFormData(object) {
    const formData = new FormData();
    for (const key in object) {
      this.commonUtil.appendFormData(formData, key, object[key]);
    }
    return formData;
  }

  getVendorPaymentData(searchFilterDto: TableSearchFilterDataDto) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/vendor_portal/sec_search_invoice_payments_v2',
      searchFilterDto, {observe: 'response'});
  }

  getBalanceAmount(paymAmount, billID) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_discount_for_payment', {
      params: {billId: billID, paymentAmount: paymAmount}, observe: 'response'
    });
  }

  /**
   * This service use for get provider list
   */
  getPaymentTypeList() {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_types',
      {observe: 'response', withCredentials: true});
  }


  /**
   * upload user list
   * @param file to uploaded file
   * @param unattended to identify whether the payment upload is attended or not
   */
  uploadPaymentFileList(file: File, unattended) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_upload_payment_request_list_csv',
      formData, {observe: 'response', withCredentials: true, params: {unattended}});
  }


  getUploadedPercentage(fileId) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_request_upload_percentage',
      {observe: 'response', withCredentials: true, params: {uuid: fileId}});
  }

  getUploadedFileIssue(fileId) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_request_upload_issues',
      {observe: 'response', withCredentials: true, params: {uuid: fileId}});
  }

  /**
   * This service use for download payment file upload template
   */
  downloadPaymentFileListUploadTemplate() {
    return this.http
      .get(ApiEndPoint.API_URL + '/payment_service/sec_download_payment_request_upload_template',
        {
          responseType: 'blob',
          withCredentials: true
        })
      .pipe(map(res => {
        return {
          filename: 'filename.pdf',
          data: new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        };
      }));
  }


  /**
   * This service use for get provider list
   */
  getPaymentProviders() {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_providers',
      {observe: 'response', withCredentials: true});
  }

  /**
   * This service use to reject transaction
   */
  rejectPayment(transaction) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_reject_transaction', transaction, {
      observe: 'response', withCredentials: true
    });
  }

  /**
   * This service use to approve and re-assign transaction
   */
  approveAndReassignPayment(transaction) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_approve_and_reassign_transaction', transaction, {
      observe: 'response', withCredentials: true
    });
  }

  /**
   * This service use to approve and finalize transaction
   */
  approveAndFinalizePayment(transaction) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_approve_and_finalize_transaction', transaction, {
      observe: 'response', withCredentials: true
    });
  }

  createPayment(payment) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_create_bulk_transaction',
      this.getFormData(payment), {observe: 'response'});
  }

  createProcessPayment(payment) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_payment_create_for_request',
      payment, {observe: 'response'});
  }

  getSummaryForPayment(payment) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_get_transaction_list_grouped_by_vendor',
      this.getFormData(payment), {observe: 'response'});
  }

  getErrorSummaryForProcessPayment(payment) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_get_grouped_request_error_summery',
      payment, {observe: 'response'});
  }

  getSummaryForProcessPayment(payment) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_get_grouped_request_summery',
      payment, {observe: 'response'});
  }



  getProcessPaymentRequestList(searchFilterDto: TableSearchFilterDataDto, batchId) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_get_process_payment_request_list_batch_wise',
      searchFilterDto, {observe: 'response', withCredentials: true, params: {batchId}});
  }


  getProcessAdditionalApproversList(searchFilterDto: TableSearchFilterDataDto, batchId , transactionIdList) {
    const body = {
      gridSearchDtoV2: searchFilterDto ,
      transactionIdList
    };
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_get_transaction_list_by_batch_id',
      body, {observe: 'response', withCredentials: true, params: {batchId}});
  }

  getProcessPaymentRequestBatchList(searchFilterDto: TableSearchFilterDataDto) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_get_process_payment_batch_list',
      searchFilterDto, {observe: 'response', withCredentials: true});
  }

  getProcessAdditionalApproversBatchList(searchFilterDto: TableSearchFilterDataDto, batchIdList) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_get_process_payment_batch_list_for_quick_approve',
      searchFilterDto, {observe: 'response', withCredentials: true, params: {batchIdList}});
  }


  /**
   * payment audit trial
   */
  getAuditTrial(idParam) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_view_transaction_audit_trail',
      {observe: 'response', params: {transactionId: idParam}});
  }


  getCheckPreview(checkId, isDetailView) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_view_payments_receipts_of_check',
      {
        params: {transactionId: checkId, isDetailView},
        responseType: 'blob',
        observe: 'response',
        withCredentials: true
      })
      .pipe(map(res => {
        return {
          filename: 'filename.pdf',
          result: res,
          data: new Blob([res.body], {type: 'application/pdf'})
        };
      }));
  }


  /**
   * payment audit trial
   */
  getVCardAuditTrial(id) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_view_v_card_audit_trail',
      {observe: 'response', params: {id}});
  }


  getVcardRelatedDocuments(cardId) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_v_card_related_documents',
      {observe: 'response', params: {cardId}});
  }

  /**
   * This method use for change the expense record from payment
   * @param object BillPaymentChangeDto
   */
  changeTaggedExpense(object) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_change_invoice',
      object, {observe: 'response'});
  }

  getPendingIdList(tableSearch) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_get_transaction_id_list', tableSearch, {
      observe: 'response', withCredentials: true
    });
  }

  getPaymentsIdList(fromDate, toDate){
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_dashboard_transaction_id_list', {observe: 'response', params: {fromDate, toDate}});
  }

  getVCardTableData(searchFilterDto: TableSearchFilterDataDto) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_search_v_card_list',
      searchFilterDto, {observe: 'response'});
  }

  getVCardData(id) {
    let url = '/payment_service/sec_view_v_card';
    if (this.privilegeService.isVendor()) {
      url = '/payment_service/sec_view_vendor_digital_card';
    }
    return this.http.get<any>(ApiEndPoint.API_URL + url,
      {observe: 'response', params: {id}});
  }


  updateVCardData(obj) {
    return this.http.put(ApiEndPoint.API_URL + '/payment_service/sec_edit_v_card', obj,
      {observe: 'response'});
  }

  cancelVCard(id, cancelReason) {
    return this.http.post<any>(ApiEndPoint.API_URL + '/payment_service/sec_cancel_v_card', cancelReason,
      {observe: 'response', params: {id}});
  }

  getCardRelatedTransactions(id) {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_get_v_card_related_transactions',
      {observe: 'response', params: {id}});
  }

  getTransactionRelatedTransactions(txnId) {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_get_check_related_transactions',
      {observe: 'response', params: {txnId}});
  }

  getACHTransactionRelatedTransactions(txnId) {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_get_ach_related_transactions',
      {observe: 'response', params: {txnId}});
  }


  getTransactionOnHoldAndRelease(transactionId, paymentTypeId) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_get_related_transactions', {},
      {observe: 'response', params: {transactionId, paymentTypeId}});
  }


  getCommunityVendorList(isCreate?) {
    return this.http.get<DropdownDto[]>(ApiEndPoint.API_URL + '/vendor_portal/sec_community_vendor_dropdown_list_v2',
      {observe: 'response', withCredentials: true});
  }

  getCommunityVendorRelatedUserList(vendorId) {
    return this.http.get<DropdownDto[]>(ApiEndPoint.API_URL + '/vendor_portal/sec_community_vendor_user_dropdown_list_v2',
      {observe: 'response', withCredentials: true, params: {vendorId}});
  }

  getEmployeeDetails(userName) {
    return this.http.put(ApiEndPoint.API_URL + '/user_management/sec_view_user_by_user_name', userName,
      {observe: 'response', withCredentials: true});
  }

  getVendorEmployeeDetails(vendorId, userName) {
    return this.http.get<DropdownDto[]>(ApiEndPoint.API_URL + '/vendor_portal/sec_community_vendor_user_details',
      {observe: 'response', withCredentials: true, params: {userName, vendorId}});
  }

  addDCardData(obj) {
    return this.http.post<any>(ApiEndPoint.API_URL + '/payment_service/sec_create_digital_card', obj,
      {observe: 'response'});
  }

  /**
   * This service use for get data from backend to grid in Vendor Community
   * @param searchFilterDto TableSearchFilterDataDto
   */
  getDigitalCardsGridDataVendorCommunity(searchFilterDto: TableSearchFilterDataDto) {
    return this.http.post<any[]>(ApiEndPoint.API_URL + '/payment_service/sec_search_digital_card_list_for_vendor_user', searchFilterDto,
      {observe: 'response'});
  }


  inactiveCard(id) {
    return this.http.put(ApiEndPoint.API_URL + '/payment_service/sec_inactivate_digital_card', {},
      {observe: 'response', params: {id}});
  }

  activeCard(id) {
    return this.http.put(ApiEndPoint.API_URL + '/payment_service/sec_activate_digital_card', {},
      {observe: 'response', params: {id}});
  }

  getIntegratedProvidersStatus() {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_provider_connected',
      {observe: 'response'});
  }


  getPaymentMailOption() {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_mail_option_for_vendors',
      {observe: 'response'});
  }

  getFundingAccountOverlayDetails(id) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_bank_details',
      {observe: 'response', params: {id}});
  }

  /**
   * This service use for download payment status advice file
   * @param selectedDateRsnge start-date and end-date object
   */
  exportPaymentStatusAdvice(selectedDateRsnge) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_export_bulk_all_status_payment_v2', selectedDateRsnge,
      {
        responseType: 'blob',
        observe: 'response',
        withCredentials: true
      })
      .pipe(map(res => {
        return {
          filename: 'payment_status_advice.csv',
          result: res,
          data: new Blob([res.body], {type: 'application/csv'})
        };
      }));
  }

  /**
   * This service use for create new automated payment configuration
   * @param configuration form data of configuration
   */
  configureAutomatedPayment(configuration) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_configure_unattended_payment',
      configuration, {observe: 'response', withCredentials: true});
  }

  /**
   * This service use for create new automated payment configuration
   * @param id configuration id
   */
  getConfiguredAutomatedPaymentDetails(id) {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_get_unattended_payment_details',
      {observe: 'response', params: {id}});
  }

  /**
   * This service use for get users and approval group list
   */
  getNotificationUserAndGroupList() {
    return this.http.get<any>(ApiEndPoint.API_URL + '/user_management/sec_get_approval_group_and_user_list',
      {observe: 'response'});
  }

  /**
   * This service use for get unattended payment id
   */
  getAutomatedPaymentConfigurationId() {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_get_unattended_payment_configuration_id',
      {observe: 'response'});
  }

  /**
   * This service use for create new automated payment configuration
   * @param enableAutomatedPayment automated payment enable or disable
   */
  removeUnattendedPaymentConfiguration(enableAutomatedPayment) {
    return this.http.get<any>(ApiEndPoint.API_URL + '/payment_service/sec_update_unattended_payment_status',
      {observe: 'response', params: {enableAutomatedPayment}});
  }

  getAuditTrialUnAttendedPayment(idParam) {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_view_unattended_payment_audit_trail',
      {observe: 'response', params: {transactionId: idParam}});
  }

  getBulkCancelPaymentRequestList(obj) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_cancel_payment_request', obj,
      {observe: 'response'});
  }

  getBulkOnHoldPaymentRequestList(obj) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_hold_payment_request', obj,
      {observe: 'response'});
  }

  getBulkReleasePaymentRequestList(obj) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_release_payment_request', obj,
      {observe: 'response'});
  }

  getBulkDeletePaymentRequestList(obj) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_delete_payment_request', obj,
      {observe: 'response'});
  }

  /**
   * This service use for get users and approval group list
   */
  getUserAndGroupList(createdBy, authorities) {
    return this.http.get<DropdownDto[]>(ApiEndPoint.API_URL + '/user_management/sec_get_all_approvers_and_groups',
      {params: {createdBy, authorities}, observe: 'response'});
  }

  getSavedConfiguration() {
    return this.http.get(ApiEndPoint.API_URL + '/payment_service/sec_get_payment_request_tenant_field_mapping_config', {observe: 'response'});
  }

  /** * This service use for upload payment configure files * @param file uploaded file */
  uploadPaymentConfigureFiles(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put(ApiEndPoint.API_URL + '/payment_service/sec_preview_payment_request_file', formData, {
      withCredentials: true,
      observe: 'response'
    });
  }

  createPaymentRequest(dto: any) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_create_payment_request_tenant_field_mapping_config', dto, {observe: 'response'});
  }

  /**
   * This service use for create new automated payment configuration
   * @param configuration form data of configuration
   */
  apiSyncConfiguration(configuration) {
    return this.http.post(ApiEndPoint.API_URL + '/payment_service/sec_configure_api_integration_payment',
      configuration, {observe: 'response', withCredentials: true});
  }

  /**
   * This service use for create new automated payment configuration
   */
  getAPIServiceDetails() {
    return this.http.get<any>(ApiEndPoint.API_URL + '/integration/sec_get_api_integrated_payment_service_status',
        {observe: 'response'});
  }

}
